import { registerI18n } from '@videojs/cdn/i18n-registry';
import translations from '@videojs/core/i18n/locales/pt-PT';

registerI18n('pt-PT', translations);
